module.exports = __webpack_public_path__ + "static/media/support.d4736f6d.png";